import React, { Component } from "react";
import * as Yup from "yup";
import _ from "lodash";
import { connect } from "react-redux";
import { FormGridField } from "../../../../utils/forms/components/FormGrid";

import Form from "../../../../utils/forms/components/Form";
import { VppsActionCreators } from "../../actions/actionCreators";
import { vppsStoreSelectors } from "../../store/store";
import { ActionCreator } from "../../../../actions/actions";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

import { CreationModes } from "../../reducers/creationMode.reducer";
import { SubsidiaryUtils } from "../../../../utils/Subsidiary/SubsidiaryUtils";

import "./CreateVpp.component.scss";

const vppFormFields = _.memoize(({ subsidiaries }): FormGridField[] => [
    {
        name: "name",
        fieldType: "input",
        fieldOptions: {
            id: "name",
            placeholder: "Name",
            label: "Name"
        },
        validation: Yup.string()
            .required("Field is required.")
            .max(50, "Max. 50 characters."),
        columnClass: "col-6"
    },
    {
        name: "subsidiary",
        fieldType: "select",
        fieldOptions: {
            id: "subsidiary",
            noValueLabel: "Choose a subsidiary...",
            label: "Subsidiary",
            items: SubsidiaryUtils.subsidiarySelectItems(subsidiaries)
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-6"
    }
]);

export interface CreateVppProps {
    creatingVpp: {
        values: any;
        isValid: boolean;
    };
    creationMode: any;
    updateCreatingVpp: ActionCreator;
    clearCreateVpp: ActionCreator;
    creatingVppLoading: boolean;
    createVpp: any;
    subsidiaryList: any[];
}

class CreateVpp extends Component<CreateVppProps> {
    form: React.RefObject<Form>;

    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    onCreate = () => {
        if (!this.props.creatingVppLoading) {
            let vpp = { ...this.props.creatingVpp.values };
            this.props.createVpp(vpp);
        }
    };

    formChange = e => {
        let values = { ...e.values };
        let isFormValid = e.isValid;
        let hasFile = false;
        if (
            this.props.creatingVpp &&
            this.props.creatingVpp.values &&
            this.props.creatingVpp.values.file
        ) {
            values.file = this.props.creatingVpp.values.file;
            hasFile = true;
        }

        this.props.updateCreatingVpp(values, isFormValid && hasFile);
    };

    handleFile = e => {
        let values = { ...this.props.creatingVpp.values };
        values.file = e[0];

        this.props.updateCreatingVpp(
            values,
            this.form.current.state.validation.isValidSync(values) &&
                values.file
        );
    };

    render() {
        return (
            <div id="create-vpp">
                <div className="create-content">
                    <div
                        className={`new-vpp-card ${
                            this.props.creatingVppLoading
                                ? "loading-submit"
                                : ""
                        }`}
                    >
                        <div id="upload" className="row">
                            <div className="col-12">
                                <div className="label-tooltip">
                                    <label className="label">Video File</label>
                                </div>
                                <Components.FileBox
                                    displayMessage={"Drag and drop video file."}
                                    multipleFilesAllowed={false}
                                    displayIcon={""}
                                    onFilesChange={this.handleFile}
                                    files={[]}
                                />
                                <div>
                                    <label className="label-info">Maximum upload file size: 200MB</label>
                                </div>
                            </div>
                        </div>
                        <Form
                            ref={this.form}
                            fields={vppFormFields({
                                subsidiaries: this.props.subsidiaryList
                            })}
                            initialValues={
                                this.props.creatingVpp
                                    ? this.props.creatingVpp.values
                                    : null
                            }
                            onChange={this.formChange}
                        />
                        {this.props.creationMode == CreationModes.ADD_VPP && (
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        className="red-btn create-btn"
                                        disabled={
                                            !this.props.creatingVpp ||
                                            !this.props.creatingVpp.isValid
                                        }
                                        onClick={this.onCreate}
                                    >
                                        <div className="loader">
                                            <div></div>
                                            <div></div>
                                        </div>
                                        Create
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: vppsStoreSelectors.creationMode(state),
    creatingVpp: vppsStoreSelectors.creatingVpp(state),
    subsidiaryList: vppsStoreSelectors.subsidiaryList(state),
    creatingVppLoading: vppsStoreSelectors.creatingVppLoading(state)
});

const mapDispatchToProps = {
    updateCreatingVpp: VppsActionCreators.updateCreatingVpp,
    clearCreateVpp: VppsActionCreators.clearCreateVpp
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateVpp);
